export default "__VITE_ASSET__CwlxR1MG__"